interface RadioProps {
  id: number | string;
  label: string;
  register: object;
  testId?: string | null;
  value: number | string;
}

const Radio = ({ id, label, register, testId = null, value }: RadioProps) => (
  <div className="align-items-center d-flex form-check mb-3">
    <input className="form-check-input" data-testid={testId} id={String(id)} type="radio" value={value} {...register} />
    <label className="form-check-label ps-2 text-0_875" htmlFor={String(id)}>
      {label}
    </label>
  </div>
);

export default Radio;
